import { Dispatch } from "react";
import {
  HeldEmailQueueAction,
  HeldEmailQueueState,
} from "../../../hooks/admin/useHeldEmailQueueState";
import { HeldEmailListItem } from "../../../services/admin/systemEmails.service";
import { HeldEmailCancelDialog } from "./HeldEmailCancelDialog";
import { HeldEmailReleaseDialog } from "./HeldEmailReleaseDialog";

interface Props {
  state: HeldEmailQueueState;
  emails: HeldEmailListItem[];
  dispatch: Dispatch<HeldEmailQueueAction>;
}

export function HeldEmailQueueDialogs({ state, emails, dispatch }: Props) {
  return (
    <>
      <HeldEmailReleaseDialog
        dispatch={dispatch}
        emails={emails}
        state={state}
      />
      <HeldEmailCancelDialog dispatch={dispatch} state={state} />
    </>
  );
}
